/** The query parameter by which a player names its `<audio>` element to the stream endpoint. */
export const ELEMENT_PARAM = 'el'

/** The stream's URL for one mounted element: the endpoint answers that element's range-less GET from
 *  byte 0 once, and refuses its repeats. */
export function streamUrlForElement(streamUrl: string, elementId: string): string {
    return `${streamUrl}${streamUrl.includes('?') ? '&' : '?'}${ELEMENT_PARAM}=${encodeURIComponent(elementId)}`
}

export function newElementId(): string {
    return typeof crypto !== 'undefined' && 'randomUUID' in crypto
        ? crypto.randomUUID().slice(0, 12)
        : String(Math.random()).slice(2, 14)
}
